import { render, staticRenderFns } from "./barDetail.vue?vue&type=template&id=2d34a0f8&scoped=true&"
import script from "./barDetail.vue?vue&type=script&lang=js&"
export * from "./barDetail.vue?vue&type=script&lang=js&"
import style0 from "./barDetail.vue?vue&type=style&index=0&id=2d34a0f8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d34a0f8",
  null
  
)

export default component.exports